<template>
	<div class="login">
		<img class="login_img" src="../assets/login/banner.png" alt="">
		<div class="nav">
			<div class="list" v-for="(item,index) in navlist" :key='index' @click="changeActive(index)">{{item}}
				<div class="activeList" v-if="active == index"></div>
			</div>
		</div>
		<div class="content" v-show="active == 1">
			<div class="list">
				<img class="listIcon" src="../assets/login/phone.png" alt="">
				<input class="val" type="text" placeholder="输入手机号" v-model="loginForm.phone">
				<img class="listClose" src="../assets/login/close.png" alt="">
			</div>
			<div class="list">
				<img class="listIcon" src="../assets/login/vscode.png" alt="">
				<input class="val" type="text" placeholder="动态密码" v-model="loginForm.vscode">
				<div class="yzmBtn" @click="getVsCode">获取验证码</div>
			</div>
		</div>
		<div class="content" v-show="active == 0">
			<div class="list">
				<img class="listIcon" src="../assets/login/user.png" alt="">
				<input class="val" type="text" placeholder="输入众享乐账号" v-model="loginForm.userName">
				<img class="listClose" src="../assets/login/close.png" alt="">
			</div>
			<div class="list">
				<img class="listIcon" src="../assets/login/pass.png" alt="">
				<input class="val" type="password" placeholder="请输入密码" v-model="loginForm.password">
			</div>
		</div>
		<div class="loginBtn" @click="login">登陆</div>
		<div class="agreement">登陆即代表阅读并同意<div>商户服务条款</div>
		</div>
	</div>
</template>
<script>
	import {
		Base64
	} from 'js-base64'
	import CryptoJS from 'crypto-js'
	import RSA from '../assets/js/rsa.js'
	import {
		eventBus
	} from '../assets/js/eventBus.js';
	export default {
		data() {
			return {
				navlist: [
					'账号登录',
					'手机登录',
					// '授权登录'
				],
				loginForm: {
					phone: '',
					vscode: '',
					userName: '',
					password: '',
					authorization: '',
					authorizationPass: ''
				},
				active: 1
			}
		},
		methods: {
			changeActive(index) {
				this.active = index
			},
			getVsCode() {
				if (!this.loginForm.phone || !(/^1[3456789]\d{9}$/.test(this.loginForm.phone))) {
					return this.$toast('请输入正确的手机号码')
				}
				const url = this.apiList.login.getVsCode
				this.$toast('发送中')
				this.$http({
					url: this.$http.adornUrl(url),
					method: 'post',
					data: this.$http.adornData({
						phoneNum: this.loginForm.phone
					}, '', false)
				}).then(({
					data
				}) => {
					if (data.result) {
						// 验证码已发送
						this.$toast('验证码已发送，请注意查收')
					} else {
						this.$toast(data.msg)
					}
				})
			},
			login() {
				// 判断登录类型
				// 验证码登录
				if (this.active == 1) {
					if (!this.loginForm.phone || !(/^1[3456789]\d{9}$/.test(this.loginForm.phone))) {
						return this.$toast('请输入正确的手机号码')
					} else if (!this.loginForm.vscode) {
						return this.$toast('请输入验证码')
					}
					this.$http({
						url: this.$http.adornUrl(this.apiList.login.loginBySmsCode),
						method: 'post',
						data: this.$http.adornData({
							phoneNum: this.loginForm.phone,
							code: this.loginForm.vscode,
							userType: 2
						}, '', false)
					}).then(({
						data
					}) => {
						console.log(data, 111)
						if (data.result) {
							// 获得密码的16位长度
							const _token = data.data.token
							// 数据加密
							const WfAesUtils = {
								_KEY: '12345678900000001234567890000000', // 16位
								_IV: '1234567890000000', // 16位
								Decrypt: function(str) {
									const key = CryptoJS.enc.Utf8.parse(this._KEY)
									const iv = CryptoJS.enc.Utf8.parse(this._IV)
									const encryptedHexStr = CryptoJS.enc.Hex.parse(str)
									const srcs = CryptoJS.enc.Base64.stringify(encryptedHexStr)
									const decrypt = CryptoJS.AES.decrypt(srcs, key, {
										iv: iv,
										mode: CryptoJS.mode.CBC,
										padding: CryptoJS.pad.Pkcs7
									})
									const decryptedStr = decrypt.toString(CryptoJS.enc.Utf8)
									return decryptedStr.toString()
								}
							}
							const _reToken = WfAesUtils.Decrypt(_token)
							// 用户token
							localStorage.setItem('token', _reToken)
							// 用户ID
							localStorage.setItem('uid', data.data.userId)
							localStorage.setItem('moduleId', data.data.moduleId)
							this.$router.go(-1)
							// 判断如果不是b端用户不允许登录
							if (data.data.userType === 2) {
								// this.$router.replace('/index')
							} else {
								this.$toast('此平台只允许B端账号登录')
							}
						} else {
							this.$toast('登陆失败')
						}
					}).catch(() => {
						console.log('未知错误')
					})
				} else if (this.active == 0) {
					if (!this.loginForm.userName || !(/^1[3456789]\d{9}$/.test(this.loginForm.userName))) {
						return this.$toast('请输入正确的账号')
					} else if (!this.loginForm.password) {
						return this.$toast('请输入密码')
					}
					const vm = this
					this.$http({
						url: this.$http.adornUrl(this.apiList.login.publicKey),
						method: 'post',
						data: this.$http.adornData('', '', false)
					}).then(({
						data
					}) => {
						if (!data.result) {
							this.$message('获取公钥失败')
							return
						}
						RSA.setMaxDigits(131)
						const key = new RSA.RSAKeyPair(data.data.exponent, '', data.data.modulus)
						const loginPassword = Base64.encode(RSA.encryptedString(key, this.loginForm.password))
						// 登录获取用户token
						this.$http({
							url: this.$http.adornUrl(this.apiList.login.loginByPwd),
							method: 'post',
							data: this.$http.adornData({
								userType: 2,
								userName: this.loginForm.userName,
								pwd: loginPassword
							}, false)
						}).then(({
							data
						}) => {
							if (data.result) {
								// if(data.data.userType === 1){
								//   return this.$toast('此平台只允许B端账号登录')
								// }
								// 获得密码的16位长度
								const _token = data.data.token
								// 数据加密
								const WfAesUtils = {
									_KEY: '12345678900000001234567890000000', // 16位
									_IV: '1234567890000000', // 16位
									Decrypt: function(str) {
										const key = CryptoJS.enc.Utf8.parse(this._KEY)
										const iv = CryptoJS.enc.Utf8.parse(this._IV)
										const encryptedHexStr = CryptoJS.enc.Hex.parse(str)
										const srcs = CryptoJS.enc.Base64.stringify(encryptedHexStr)
										const decrypt = CryptoJS.AES.decrypt(srcs, key, {
											iv: iv,
											mode: CryptoJS.mode.CBC,
											padding: CryptoJS.pad.Pkcs7
										})
										const decryptedStr = decrypt.toString(CryptoJS.enc.Utf8)
										return decryptedStr.toString()
									}
								}
								const _reToken = WfAesUtils.Decrypt(_token)
								// console.log(_reToken)
								// 用户token
								localStorage.setItem('token', _reToken)
								// 用户ID
								localStorage.setItem('uid', data.data.userId)
								localStorage.setItem('moduleId', data.data.moduleId)
								this.$router.go(-1)
								// 判断如果不是b端用户不允许登录
								if (data.data.userType === 2) {

								} else {
									this.$toast('登陆失败')
								}
							}
						})
					})

				}
			},
		}
	}
</script>
<style lang="scss">
	.login {
		text-align: center;
		min-height: 100%;
		background-color: #fff;
		padding-top: 1rem;

		.login_img {
			width: 4.5rem;
		}

		.nav {
			display: flex;
			justify-content: space-around;
			padding: 0 .76rem;

			.list {
				font-size: .24rem;
				color: #171717;
			}

			.activeList {
				width: .46rem;
				height: .06rem;
				background-color: #ffac00;
				margin: 0 auto;
				margin-top: .05rem;
				border-radius: .06rem;
			}
		}

		.content {
			padding: 0 .76rem;

			.list {
				border: 1px solid #d7d7d7;
				height: .88rem;
				padding: 0 .44rem;
				border-radius: .88rem;
				display: flex;
				align-items: center;
				margin-top: .44rem;

				.listIcon {
					width: .3rem;
					object-fit: contain;
					margin-right: .1rem;
				}

				.val {
					font-size: .28rem;
					flex: 1;
					border: 0;
					outline: none;
					width: 100%;
					margin-right: .2rem;
				}

				.listClose {
					width: .28rem;
					height: .28rem;
					margin-left: .1rem;
				}

				.yzmBtn {
					font-size: .28rem;
					color: rgb(0, 161, 252);
					white-space: nowrap;
				}
			}
		}

		.loginBtn {
			width: 2.78rem;
			height: .86rem;
			border-radius: .86rem;
			text-align: center;
			background: #ffac00;
			color: #fff;
			font-size: .28rem;
			line-height: .88rem;
			margin: 2rem auto .32rem;
		}

		.agreement {
			font-size: .24rem;
			display: flex;
			align-items: center;
			justify-content: center;

			div {
				color: rgb(0, 161, 252);
			}
		}
	}
</style>



// WEBPACK FOOTER //
// src/components/login.vue